;(function ($) {
    var $menuWrapper = $('.mobile-menu');
    var $body = $("body");
    var $mobileMenu = $('.mobile-menu__link, [data-menu]');
    // var $mobileMenu = $('#mobile-menu__button');
    var $mainMenuLinks = $('.main-menu__link');
    var $langMenu = $("#lang-menu-button");
    var resizeTimer;
    var breakpoint = 900;
    var mobile = false;

    initMenu();

    //main-menu__link main-menu__link--has-sub is-selected

    $mobileMenu.click(function () {
        var data = $(this).data("menu");
        if (data) {
            hideMainmenu($(data));
        } else {
            toggleMainmenu(this);
        }
    });

    $mainMenuLinks.click(function () {
        toggleSubmenu(this);
    });

    $langMenu.click(function () {
        toggleLangMenu(this);
    });

    $(".language-menu__button").not($langMenu).click(function () {
        hideLangMenu($langMenu);
    });

    $('.submenu__title').click(function () {
        var $parent = $(this).parents('.submenu').siblings('.is-selected');
        hideSubmenu($parent);
    });

    $('.main-menu__close').click(function () {
        closeMenu();
    });

    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            onResize();
        }, 250);

    });

    function showSubmenu($item) {
        $item.addClass('is-selected');
        //disable mainmenu scroll
        // $menuWrapper.addClass('is-freezed');
    }

    function hideSubmenu($item) {
        $item.removeClass('is-selected');
        //enable mainmenu scroll
        $menuWrapper.removeClass('is-freezed');
    }

    function toggleSubmenu(item) {
        var $item = $(item);
        $item.hasClass('is-selected') ? hideSubmenu($item) : showSubmenu($item);
        hideLangMenu($langMenu);
    }

    function showMainmenu($item) {
        $mobileMenu.filter('.is-selected').removeClass('is-selected');
        $item.addClass('is-selected');
        //disable body scroll
        $body.addClass('is-freezed');
        $menuWrapper.addClass('is-open');
        //open submenu
        toggleSubmenu($(".main-menu__item.is-selected").find(".main-menu__link")[0]);
    }

    function hideMainmenu($item) {
        $item.removeClass('is-selected');
        //enable body scroll
        $body.removeClass('is-freezed');
        $menuWrapper.removeClass('is-open');
    }

    function toggleMainmenu(item) {
        var $item = $(item);
        $item.hasClass('is-selected') ? hideMainmenu($item) : showMainmenu($item);
    }

    function showLangMenu($item) {
        $item.addClass('is-selected');
    }

    function hideLangMenu($item) {
        $item.removeClass('is-selected');
    }

    function toggleLangMenu(item) {
        var $item = $(item);
        $item.hasClass('is-selected') ? hideLangMenu($item) : showLangMenu($item);
    }

    function closeMenu() {
        hideMainmenu($mobileMenu);
        hideSubmenu($mainMenuLinks);
        hideLangMenu($langMenu);
    }

    function onResize() {
        var currentW = window.innerWidth;

        if (mobile && currentW > breakpoint) {
            mobile = false;
            closeMenu();
        } else if (!mobile && currentW < breakpoint) {
            mobile = true;
            closeMenu();
        }
    }

    function initMenu() {
        if (window.innerWidth < breakpoint) {
            mobile = true;
        } else {
            mobile = false;
        }

        bindKeyboardEvents();
    }

    function bindKeyboardEvents() {
        var key = {
            BACKSPACE: 8,
            COMMA: 188,
            DELETE: 46,
            DOWN: 40,
            END: 35,
            ENTER: 13,
            ESCAPE: 27,
            HOME: 36,
            LEFT: 37,
            PAGE_DOWN: 34,
            PAGE_UP: 33,
            PERIOD: 190,
            RIGHT: 39,
            SPACE: 32,
            TAB: 9,
            UP: 38
        };
        $(document).on('keydown.twn.header', '.header', function (e) {
            if (!(/(9|37|38|39|40|27|32|13)/).test(e.which) ) return;
            if ((/input|textarea/i).test(e.target.tagName)){
                if(e.target.type !== "radio") return
            }

            var $target = $(e.target);
            // console.log(e.which, $target);

            //open, main menu
            if (e.which == key.SPACE) {
                e.preventDefault();
                e.stopPropagation();

                //close siblings
                if ($target.hasClass("main-menu__link")) {
                    $target.parent().siblings(".is-open").removeClass("is-open");
                }
                if ($target.hasClass("main-menu__link--has-sub")) {
                    // $target.trigger('click');
                    $target.parent().addClass("is-open");

                    //set focus on child
                    $target.parent().find(".submenu__link")[0].focus();
                }

            }

            // esc triggers close menu
            if (e.which == key.ESCAPE) {
                e.preventDefault();
                e.stopPropagation();

                // debugger;
                // submenu
                if ($target.hasClass("submenu__link")) {
                    var $parent = $target.parents(".main-menu__item.is-open");
                    $parent.removeClass("is-open");
                    $parent.find(".main-menu__link").focus();
                }

                else if ($target.hasClass("main-menu__link")) {
                    $target.parent().removeClass("is-open");
                }

                else {
                    $target.parents('.collapse').collapse("hide");
                }
            }

            if (e.which == key.ENTER) {
                e.preventDefault();
                e.stopPropagation();

                $target[0].click();

                if($target.data("toggle")){
                    $($target.attr("href")).find("input:checked")[0].focus();
                }
            }

            /*

            // space triggers click
            if (e.which == 32) {
                e.preventDefault();
                e.stopPropagation();

                return $(e.target).trigger('click');
            }

            // esc triggers close menu
            if (e.which == 27) {
                e.preventDefault();
                e.stopPropagation();
                if ($target.hasClass('menu__link')) {
                    if ($target.parent().hasClass('is-current')) {
                        $target.click();
                    }
                }
            }

            if (e.which == 9) {
                if ($target.hasClass('menu__link') && $target.attr('data-toggle') == 'header' && $target.parent().hasClass('is-current')) {
                    e.preventDefault();
                    e.stopPropagation();
                    $($target.attr('data-target')).find('a, input, button, select, textarea').filter(':visible:not([disabled])').first().focus();
                }
            }*/
        });
    }
}(jQuery));
